//
// Homepage functions
//
import LocomotiveScroll from 'locomotive-scroll';

export default class Homepage {
    constructor() {

        // Check that the homepage element exists
        this.homepageHtmlElement = document.querySelector(".js-homepage-scroll");
        if (!this.homepageHtmlElement) return;

        this.init();
    }

    init() {
        const locomotiveScroll = new LocomotiveScroll();

        this.addEventHandling();
    }

    /**
     * @public
    */
    toggleColourChange(event) {
        const { target, way, from } = event.detail;

        // When leaving area, remove colour
        if (way === 'leave' && from === 'end') {
            this.homepageHtmlElement.classList.remove('invertedColour');
        } else if (way === 'enter' && from === 'end') {
            this.homepageHtmlElement.classList.add('invertedColour');
        }
    }

    addEventHandling() {
        window.addEventListener('colourChange', (event) => {
            this.toggleColourChange(event);
        });
    }
}